import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';
import { Url } from '@wix/da-url';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import Timestamp from '../../../Timestamp';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { BiContextProvidedValue, BiData, ItemClickBiEvent } from '@wix/da-bi/pkg/events';
import { CommentContext } from '../../CommentContext';
import s from './CommentTimestamp.scss';

export interface Props {
  className?: string;
}

/** A timestamp with a link that goes to the comment's standalone page. */
const CommentTimestamp: React.FC<Props> = ({ className }) => {
  const { t } = useTranslation();
  const { comment } = useContext(CommentContext);
  const isMobile = useContext(MobileContext);
  const isEdited = !!comment.edited;
  const timestamp = isEdited ? comment.edited : comment.posted;
  const showEditedPrefix = isEdited && !isMobile;

  return (
    <BiLink
      href={Url.commentLink(comment.typeId, comment.itemId, comment.commentId)}
      className={c(s['root'], className)}
      biData={BiData<ItemClickBiEvent>({
        evid: 100,
        itemid: comment.itemId,
        typeid: comment.typeId,
        page_typeid: BiContextProvidedValue,
        page_itemid: BiContextProvidedValue,
        sectionid: BiContextProvidedValue,
        sectionname: BiContextProvidedValue,
        section_typeid: BiContextProvidedValue,
        sectiontype: BiContextProvidedValue,
        widgetname: BiContextProvidedValue,
      })}
    >
      {showEditedPrefix && `${t('comment.info.edited')} `}
      <Timestamp timestamp={timestamp!} showTooltip isCapitalized={!showEditedPrefix} />
    </BiLink>
  );
};
CommentTimestamp.displayName = 'CommentTimestamp';

export default CommentTimestamp;
